import styled from "styled-components";

export const Divider = () => <StyledDivider />;

const StyledDivider = styled.div`
  width: 1px;
  height: 33px;
  background: var(--bg-15);
  margin: 0 8px;
`;
